import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  provincesDealershipsAllSelectedSelector,
  provincesDealershipsSelectedFiltersSelector,
  provincesDealershipsState,
  resetProvincesDealershipsSelector,
  searchLocationTypesState,
  selectedLocationsNumberInfoSelector,
  toggleProvinceDealershipSelector,
} from '@/states/used-cars/provinces-dealerships.state';

export function useProvincesDealershipsFilter() {
  const [searchLocationTypeFilter, setSearchLocationTypeFilter] =
    useRecoilState(searchLocationTypesState);

  const [provincesDealershipsFilter, setProvincesDealershipsFilter] =
    useRecoilState(provincesDealershipsState);
  const { provincesDealershipsSelectedFilters } = useRecoilValue(
    provincesDealershipsSelectedFiltersSelector
  );
  const { provincesDealershipsAllSelected } = useRecoilValue(
    provincesDealershipsAllSelectedSelector
  );
  const { selectedLocationsNumberInfo } = useRecoilValue(
    selectedLocationsNumberInfoSelector
  );

  const resetProvincesDealerships = useSetRecoilState(
    resetProvincesDealershipsSelector
  );
  const toggleProvinceDealership = useSetRecoilState(
    toggleProvinceDealershipSelector
  );

  return {
    searchLocationTypeFilter,
    setSearchLocationTypeFilter,
    provincesDealershipsFilter,
    setProvincesDealershipsFilter,
    provincesDealershipsSelectedFilters,
    provincesDealershipsAllSelected,
    selectedLocationsNumberInfo,
    toggleProvinceDealership,
    resetProvincesDealerships,
  };
}
